import { FC } from 'react';

import { Panel } from '../PanelLayout';
import { PanelTemplateProps } from '../types';

const PrimaryPanel: FC<PanelTemplateProps> = ({
  children,
  testMetadata,
  ...otherProps
}) => {
  return (
    <Panel name="primary" {...otherProps} {...testMetadata}>
      {children}
    </Panel>
  );
};

export default PrimaryPanel;
